if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        // Bespoke PDPs (e.g. the Roto collab page) render their own buy form without the
        // standard main-product selling-plan input, so guard against a missing element.
        const sellingPlanInput = this.form.querySelector('input[name="selling_plan"]');
        const sellingPlanId = Number(sellingPlanInput ? sellingPlanInput.value : 0);
        const MAX_QTY = 20;
        const variantId = Number(this.variantIdInput.value);
        const shippingVariantId = Number(window.variant_id_shipment_protect);

        // Fall back to this form's own quantity field when the standard PDP structure is absent.
        const qtyInput =
          document.querySelector('.product__info-container quantity-input .quantity__input') ||
          this.form.querySelector('[name="quantity"]');
        let requestedQty = Number(qtyInput ? qtyInput.value : 1);
        
        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        const loadingSpinner = this.querySelector('.loading__spinner');
        if (loadingSpinner) loadingSpinner.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        fetch('/cart.js')
          .then(res => res.json())
          .then(cart => {
            let currentQtyInCart = 0;
            
            if(sellingPlanId == 0){
              cart.items.forEach(item => {
                const itemSellingPlanId = item.selling_plan_allocation
                ? item.selling_plan_allocation.selling_plan.id
                : null;

                if (item.variant_id === variantId && itemSellingPlanId === null){
                  currentQtyInCart = item.quantity;
                }
              });
            }else{
              cart.items.forEach(item => {
                const itemSellingPlanId = item.selling_plan_allocation
                ? item.selling_plan_allocation.selling_plan.id
                : null;

                if (item.variant_id === variantId && itemSellingPlanId === sellingPlanId) {
                  currentQtyInCart = item.quantity;
                }
              });
            }

            const allowedQty = MAX_QTY - currentQtyInCart;

            if (allowedQty <= 0) {
              this.showQtyError(
                `You can only add up to ${MAX_QTY} units of this product. You already have ${MAX_QTY} in your cart.`
              );
              throw new Error('MAX_LIMIT_REACHED');
            }

            if (requestedQty > allowedQty) {
              requestedQty = allowedQty;
              if (qtyInput) qtyInput.value = allowedQty;
            }

            const formData = new FormData(this.form);
            formData.set('quantity', requestedQty);

            if (window.shipment_protect_active === true) {
              formData.append('items[1][id]', shippingVariantId);
              formData.append('items[1][quantity]', requestedQty);
            }

            if (this.cart) {
              formData.append(
                'sections',
                this.cart.getSectionsToRender().map((section) => section.id)
              );
              formData.append('sections_url', window.location.pathname);
              this.cart.setActiveElement(document.activeElement);
            }
            config.body = formData;

            return fetch(`${routes.cart_add_url}`, config);
          })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: this.variantIdInput.value,
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
            
             /*if (!this.error) {
              if (window.shipment_protect_active == true) {
                var checkbox = document.querySelector("#content-switch-protect .input-toggle-shipment-protect");
                checkbox.checked = true;
                checkbox.dispatchEvent(new Event('change', { bubbles: true }));
              }
             }*/


          })
          .catch((e) => {
            console.error(e);
          })
          .finally((response) => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            const loadingSpinnerDone = this.querySelector('.loading__spinner');
            if (loadingSpinnerDone) loadingSpinnerDone.classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      showQtyError(message) {
        if (this.hideErrors) return;

        const errorBox = document.querySelector('#errorcart');
        if (!errorBox) return;

        errorBox.textContent = message;
        errorBox.style.display = 'block';

        window.scrollTo({
          top: errorBox.offsetTop - 200,
          behavior: 'smooth'
        });

        /*clearTimeout(this.errorTimeout);
        this.errorTimeout = setTimeout(() => {
          errorBox.style.display = 'none';
        }, 7000);*/

      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
